var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('media-image-display-and-management',{ref:"imageManagement",attrs:{"media-able-id":_vm.productId,"possible-labels":_vm.getPossibleLabels,"media-able-type":"product"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }